<template>
  <IconWrapper name="arrow" :color="color" fillMode="fill">
    <svg
      :style="{ rotate: `${rotation}deg` }"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.34 6.09014C13.34 7.86414 14.118 9.52915 15.339 10.7501L3 10.7501L3 12.7501L15.339 12.7501C14.118 13.9721 13.34 15.6372 13.34 17.4102L13.34 18.4102L15.34 18.4102L15.34 17.4102C15.34 14.9722 17.561 12.7501 20 12.7501L21 12.7501L21 10.7501L20 10.7501C17.561 10.7501 15.34 8.52814 15.34 6.09014L15.34 5.09014L13.34 5.09014L13.34 6.09014Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  rotation?: number | string
}>()
</script>
